import React from 'react'

import axios from "axios";
import ArticlePostItem from "../../../post/ArticlePostItem";
import VideoPostItem from "../../../post/VideoPostItem";
import AudioPostItem from "../../../post/AudioPostItem";
import PhotosPostItem from "../../../post/PhotosPostItem";
import LinkPostItem from "../../../post/LinkPostItem";
import QuotePostItem from "../../../post/QuotePostItem";
import {authService} from "../../../auth";
import {NavLink, withRouter} from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import SharePostItem from "../../../post/SharePostItem";
import cloneDeep from 'lodash/cloneDeep';

import $ from "jquery";
import LazyLoad from "react-lazyload";
import { userAgentGetData } from '../../../commons/CommonFunctions';
import PresentationPostItem from '../../../post/PresentationPostItem';
import CleverTapUtils from '../../../commons/CleverTapUtils';
import ProjectPostNavBar from './ProjectPostNavBar';


class ProjectActivity extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            postList: [],
            userData: authService.getUserDetailsFromLocalStorage(),
            responseMessage: '',
            postMaxSize: 5,
            thresholdHeight: 1000,
            participantList : "",
            circleAdminList:""

        };
        this.getLatestPosts = this.getLatestPosts.bind(this);
    }

    componentDidMount() {
        this.getLatestPosts(0, this.state.postMaxSize, false);
        //this.getProjectDetails();
        //this.getCircleAdminList();
    }

    getProjectDetails() {
        axios({
            method: 'get',
            url:
                process.env.REACT_APP_userServiceURL +
                "/backend/participation/get-participant-list/" +
                this.props.project.id ,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                this.setState({participantList : response.data.body});
                this.props.getParticipantsCircleAdminList("participantList", response.data.body);
            }
        }).catch((err) => {
            console.log(err);
        });
    };


    getCircleAdminList() {
        axios({
            method: "get",
            url: process.env.REACT_APP_userServiceURL + '/backend/circle/getCircleMember/' +this.props.project.userId ,
            headers: {"Content-Type": "application/json"},
            withCredentials: true,
        })
            .then((response) => {
                if (response && response.data && response.data.message === 'Success!') {
                    this.setState({circleAdminList : response.data.body});
                    this.props.getParticipantsCircleAdminList("circleAdminList", response.data.body)
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    fetchMorePostData() {
        let postList = this.state.postList;
        if (this.state.postList) {
            let pageable = postList.pageable;
            if(pageable.pageNumber < 40){
                this.setState({isResultLoading: true});
                this.getLatestPosts(pageable.pageNumber + 1, this.state.postMaxSize, true);
            }
        }
    }

    callback_fn = (userId) => {
        this.updateFollowList(userId)
    }

    updateFollowList = (userId) => {
        if (this.state.postList && this.state.postList.content && this.state.postList.content.length > 0) {
            let postList = cloneDeep(this.state.postList);
            postList && postList.content && postList.content.forEach((item) => {
                if (item.userId === userId) {
                    item.followed = !item.followed;
                }
            });
            this.setState({'postList': postList});
        }
    }


    getLatestPosts(page, size, concatWithPrevious) {
        if(!page){
            page = 0;
        }if(!size){
            size = 5;
        }if(concatWithPrevious === undefined){
            concatWithPrevious = false;
        }
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/post/project/getNewsFeed?projectId=' + this.props.project.id + '&userId=' + this.state.userData.userId + '&newsFeedType=LATEST' + "&page=" + page + "&size=" + size + userAgentGetData(),
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.status === 200) {
                let pagedData = response.data.body;
                if (concatWithPrevious === true && this.state.postList && this.state.postList.content) {
                    pagedData.content = this.state.postList.content.concat(pagedData.content);
                }
                this.setState({
                    'postList': pagedData,
                    'responseMessage': response.data.message,
                    'isResultLoading': false
                }, () => {
                    //this.props.getPostCount(pagedData?.content?.length);
                    let postListHeight = $('.hpostlist').height();
                    if (postListHeight && postListHeight > 0) {
                        if (!this.state.initialThresholdHeight) {
                            this.setState({
                                'initialThresholdHeight': postListHeight,
                                'thresholdHeight': postListHeight * 0.6
                            });
                        }
                    }
                });
            }
        }).catch((err) => {
            console.log(err);
            this.setState({
                isResultLoading: false
            });
        });
    }

    removePostListItem = (id) => {
        let postItemList = this.state.postList;
        const index = postItemList && postItemList.content.findIndex(data => data.id === id);
        if (index > -1) {
            postItemList.content.splice(index, 1); 
        }
        this.setState({
          postList: postItemList
        });
        if(postItemList?.content.length === 0) {
            this.getLatestPosts(!postItemList.last ? postItemList.pageable.pageNumber + 1 :  0, this.state.postMaxSize, false);
        }
        this.forceUpdate();
    }

    onSuccessPinPostRequest = (item) => {
        let postItemList = this.state.postList;
        if(item.pinned) {
            const index = postItemList && postItemList.content.findIndex(data => data.id === item.id);
            if (index > -1) {
                postItemList.content.splice(index, 1); 
                postItemList.content = postItemList.content.filter(data => { data.pinned = false; return data;});
                postItemList.content = [item].concat(postItemList.content);
            }
        } else {
            postItemList.content = postItemList.content.filter(data => { data.pinned = false; return data;});
        }
        this.setState({
          postList: postItemList
        });
        
        this.forceUpdate();
    }

    render() {
        let content;
        if (this.props.project && this.props.project && this.props.project.demolished &&
            this.props.project.demolished === true && this.props.project.demolishedDate &&
            this.props.project.demolishedDate > 0) {
            content = <>
                <div className="projCancelWrap">
                    <div className="imgbox"><img src="https://cdn.dscovr.com/images/zeroDeleteProject.webp"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "https://cdn.dscovr.com/images/zeroDeleteProject.png"
                                                }} style={{width: '250px'}} alt=""/>
                    </div>
                    <p>Project
                        was {this.props.project && this.props.project.demolishedType && this.props.project.demolishedType.toLowerCase()}
                        <span>on {new Date(this.props.project.demolishedDate).toLocaleDateString('en-GB', {
                            day: '2-digit', month: 'short', year: 'numeric'
                        }).replace(/ /g, '-')}</span></p></div>
            </>

        } else {
            content = <ProjectPostNavBar
                project={this.props.project}
                projectId={this.props.project.id}
                userId={this.state.userData.userId}
            />

            // if (this.state.postList && this.state.postList.content && this.state.postList.content.length === 0
            //     && this.state.responseMessage === "Success!" && this.state.postList.empty === true) {
            //     content = <div className="zdata zfeed">
            //         <div className="imgbox"><img src="https://cdn.dscovr.com/images/zroProjectsActivity.webp" onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/zroProjectsActivity.png"}} alt=""/></div>
            //         <div className="desc">
            //             {(this.props.project && /* !this.props.project.privateProject && */ (this.props.project &&  this.props.project.creatorUserId === this.state.userData.userId ||
            //                 this.props.project.userId === this.state.userData.userId ||
            //                 this.state.circleAdminList.includes(this.state.userData.userId)||
            //                 (this.state.participantList.includes(this.state.userData.userId) && this.props?.project?.project?.projectParticipantPermission?.post) ||
            //                 this.props.project && (
            //                 this.props.project.companyIds && this.props.project.companyIds.includes(this.props.project.creatorUserId)) || this.props.project.editPermission)) ?
            //             <p><a href="#addpostpop" data-toggle="modal" onClick={() => {CleverTapUtils.eventClick({}, "Create Event");}}>Share</a> your thoughts</p> :
            //             <p>No Activity</p>
            //             }
            //         </div>
            //     </div>
            // }

            // if (this.state.postList && this.state.postList.content && this.state.postList.content.length > 0
            //     && this.state.responseMessage === "Success!" && this.state.postList.empty === false) {
            //     content = <section className="hpostlist"><InfiniteScroll
            //         loadMore={this.fetchMorePostData.bind(this)}
            //         hasMore={!this.state.isResultLoading && !this.state.postList.last}
            //         threshold={this.state.thresholdHeight}
            //         loader={<section>
            //             {Array(1)
            //                 .fill()
            //                 .map((item, index) => (
            //                     <SkeletonTheme>
            //                         <div className="hpostblock" key={index}>
            //                             <figure className="userimg">
            //                                 <Skeleton circle={true} height={50} width={50}/>
            //                             </figure>
            //                             <div className="hpostblockinn">
            //                                 <div className="hposthead">
            //                                     <h3>
            //                                         <Skeleton height={36} width={`80%`}/>
            //                                     </h3>
            //                                     <div className="hpostdtls">
            //                                         <Skeleton height={36} width={`30%`}/>
            //                                     </div>
            //                                     <div className="hpostcontent">
            //                                         <div className="hpostconttop">
            //                                             <p><Skeleton height={120} width={`100%`}/></p>
            //                                         </div>
            //                                     </div>
            //                                     <div className="card-metrics">
            //                                         <Skeleton width={`90%`}/>
            //                                     </div>

            //                                 </div>
            //                             </div>
            //                         </div>
            //                     </SkeletonTheme>
            //                 ))}
            //         </section>}>
            //         {
            //             this.state.postList && this.state.postList.content && this.state.postList.content.map((item) => {
            //                 return item.postType === 'ARTICLE'
            //                     ? <ArticlePostItem enablePostSharing={true} item={item} key={item.id}
            //                                        callbackFunc={this.getLatestPosts}
            //                                        callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} />
            //                     : (item.attachmentIds && item.attachmentIds.length > 0)
            //                         ? (item.attachmentIds[0].attachmentType === 'VIDEO' ?
            //                                 <LazyLoad once><VideoPostItem enablePostSharing={true} item={item}
            //                                                               key={item.id}
            //                                                               callbackFunc={this.getLatestPosts}
            //                                                               callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} /></LazyLoad>
            //                                 : (item.attachmentIds[0].attachmentType === 'AUDIO' ?
            //                                         <LazyLoad once><AudioPostItem enablePostSharing={true} item={item}
            //                                                                       key={item.id}
            //                                                                       callbackFunc={this.getLatestPosts}
            //                                                                       callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} /></LazyLoad>
            //                                         :(item.attachmentIds[0].attachmentType === 'PPT' || item.attachmentIds[0].attachmentType === 'PDF') ? 
            //                                             <LazyLoad once><PresentationPostItem enablePostSharing={true} item={item} key={item.id}
            //                                                 callbackFunc={this.getLatestPosts} callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} /></LazyLoad>
            //                                                 :<LazyLoad once><PhotosPostItem enablePostSharing={true} item={item}
            //                                                                             key={item.id}
            //                                                                             callbackFunc={this.getLatestPosts}
            //                                                                             callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} /></LazyLoad>
            //                                 )
            //                         )
            //                         : (item && item.attachmentIds.length === 0 && item.paidPost && (item.attachmentType === "IMAGE" || item.attachmentType === "VIDEO"))
            //                         ? item.attachmentType === "IMAGE" ?
            //                             <LazyLoad once>
            //                                 <PhotosPostItem enablePostSharing={true} item={item}
            //                                                                        key={item.id}
            //                                                                        callbackFunc={this.getLatestPosts}
            //                                                                        callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} />
            //                             </LazyLoad> : 
            //                             item.attachmentType === "VIDEO" ? 
            //                                 <LazyLoad once>
            //                                     <VideoPostItem enablePostSharing={true} item={item}
            //                                                               key={item.id}
            //                                                               callbackFunc={this.getLatestPosts}
            //                                                               callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} /></LazyLoad> : 
            //                             <></>
            //                         : (item.postType === 'LINK')
            //                             ?
            //                             <LazyLoad once><LinkPostItem enablePostSharing={true} item={item} key={item.id}
            //                                                          callbackFunc={this.getLatestPosts}
            //                                                          callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} /></LazyLoad> : (item.sharedEntityId && item.sharedEntityId !== '')
            //                                 ? <SharePostItem enablePostSharing={true} item={item} key={item.id}
            //                                                  callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} />
            //                                 : <QuotePostItem enablePostSharing={true} item={item} key={item.id}
            //                                                  callbackFunc={this.getLatestPosts}
            //                                                  callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} onSuccessPinPostRequest={this.onSuccessPinPostRequest} />
            //             })
            //         }
            //     </InfiniteScroll>
            //     </section>
            // }
        }

        return <div>{content}</div>
    }
}

export default withRouter(ProjectActivity);
